export default "__VITE_ASSET__e5590666__"